import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  z-index: 200;
`;
